import store from "@/plugins/store";
import moment from 'moment';

function PayrollHeader() {
    // public
    this.id = 0;
    this.addressbook_id = 0;
    this.rectype = 0;
    this.payroll_number = '';

	// Note, the UI just updates the id and ignores the rest of the fields here for now, may want to improve on that but
	// since we just use a dropdown it is not a serious issue
    this.left_reason = { id: 0, is_active: false, code: "None", desc: "None" };

	// private, accessed by accessors
    this._start_date = new Date();
    this._end_date = null;
	this.has_final_pay = false;
	this.is_used = false;

    Object.defineProperty(this, 'start_date', {
		get() {
			if (this._start_date){
				return moment(this._start_date).format("YYYY-MM-DD")
			} else {
				return '';
			}
		},

		set(date) {
			if (date) {
				this._start_date = new Date(date);
				// console.log("New start date",this._date);
			} else {
				this.start_date = null;
			};
        }
    })

    Object.defineProperty(this, 'end_date', {
		get() {
            if (this._end_date) {
    			return moment(this._end_date).format("YYYY-MM-DD")
            } else {
                return '';
            }
		},
		set(date) {
            if (date.length == 0) {
                this._end_date = null;
            } else {
    			this._end_date = new Date(date);
            }
			// console.log("New date",this._end_date);
        }
    })

    this.set = function(payroll_header) {
        this.id = payroll_header.id;
        this.addressbook_id = payroll_header.addressbook_id;
        this.rectype = payroll_header.rectype;
        this.payroll_number = payroll_header.payroll_number;

		this._start_date = new Date(payroll_header.start_date);
		if (payroll_header.end_date) {
			this._end_date = new Date(payroll_header.end_date);
		} else {
			this._end_date = null;
		}

		if (payroll_header.left_reason && payroll_header.left_reason.id) {
			this.left_reason = payroll_header.left_reason;
		} else {
			this.left_reason = { id: 0, is_active: false, code: "None", desc: "None" };
		}
		this.has_final_pay = payroll_header.has_final_pay;
		this.is_used = payroll_header.is_used;

    }

    // load an expense claim
	this.load = function(adbid, pahid) {
		let self = this;

		return new Promise((resolve, reject) => {
			let url = "/api/addressbook/" + adbid + "/payrollheader/" + pahid;

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					let json = d.data;

					if (json.status == "OK") {
						// parse our new data
						self.set(json.data);

						// console.log(self)

						resolve();
					} else {
						reject(json.reason);
					}
				})
				.catch(function(e) {
					reject(e.message);
				});
		})
	}

	this.insert = function() {
		let self = this;

		return new Promise((resolve, reject) => {
			// build our url parameters
			let params = new Array();
			// params.push("something=true");

			// build our url, we have to add url escaping here!
			let url = "/api/addressbook/" + self.addressbook_id + "/payrollheader";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.post(url, {
					type_id: self.rectype,
					start_date: self.start_date
					// other fields are ignored on insert
				}, {
					headers: {
						"Authorization": "Bearer " + store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					// this is the result of the last search we've started, lets process it.
					let json = d.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					if (json.status == "OK") {
						// parse our new data
						self.set(json.data);

						resolve(json.data);
					} else {
						console.log(json.reason);
						reject(json.reason);
					}
				})
				.catch(function(e) {
					// this is the error for the last search we've started, lets show it.
					console.log(e);
					reject(e.message);
				})
		});
	}

	this.update = function() {
		let self = this;

		return new Promise((resolve, reject) => {
			// build our url parameters
			let params = new Array();
			// params.push("something=true");

			// build our url, we have to add url escaping here!
			let url = "/api/addressbook/" + self.addressbook_id + "/payrollheader/" + self.id;
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			axios
				.put(url, {
					type_id: self.rectype,
					start_date: self.start_date,
					end_date: self.end_date,
					left_reason: self.left_reason.id
				}, {
					headers: {
						"Authorization": "Bearer " + store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					// this is the result of the last search we've started, lets process it.
					let json = d.data;

					// For some reason axios isn't always converting our data
					if ((typeof json) == "string") {
						json = JSON.parse(json);
					}

					if (json.status == "OK") {
						// parse our new data
						self.set(json.data);

						resolve();
					} else {
						reject(json.reason);
					}
				})
				.catch(function(e) {
					reject(e.message);
				});	
		});
	}

	this.delete = function() {
		let self = this;

		return new Promise((resolve, reject) => {
			let url = "/api/addressbook/" + self.addressbook_id + "/payrollheader/" + self.id;
			axios
				.delete(url, {
				}, {
					headers: {
						"Authorization": "Bearer " + store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					// Don't ask me why it does work here... 
					let json = d.data;
					
					if (json.status == "OK") {
						// self.set(json.data);
						resolve();
					} else {
						console.log(json.reason);
						reject(json.reason);
					}
				})
				.catch(function(e) {
					console.log(e);
					reject(e.message);
				})

		})		
	}
}

export default PayrollHeader;
